// Logos servidos por Simple Icons (SVG monocromo). Si alguno no está disponible,
// se muestra el nombre de la marca como texto.
export const brandLogos = [
  { name: 'Fiat', slug: 'fiat', icon: 'fiat' },
  { name: 'Volkswagen', slug: 'volkswagen', icon: 'volkswagen' },
  { name: 'Ford', slug: 'ford', icon: 'ford' },
  { name: 'Jeep', slug: 'jeep', icon: 'jeep' },
  { name: 'BAIC', slug: 'baic', icon: 'baic' },
  { name: 'Chevrolet', slug: 'chevrolet', icon: 'chevrolet' },
  { name: 'Peugeot', slug: 'peugeot', icon: 'peugeot' },
  { name: 'Toyota', slug: 'toyota', icon: 'toyota' },
  { name: 'Renault', slug: 'renault', icon: 'renault' },
  { name: 'Citroën', slug: 'citroen', icon: 'citroen' },
];
